'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = throttle;
exports.getDate = getDate;
exports.getCurrentPageUrl = getCurrentPageUrl;
exports.printMsg = printMsg;
/**
 * 频率控制 返回函数连续调用时，func 执行频率限定为 次
 * 
 * @param  {function}   fn      传入函数
 * @param  {number}     gapTime 表示时间窗口的间隔
 * @return {function}           返回客户调用函数
 */
function throttle(fn, gapTime, waitfn) {
  if (gapTime === null || typeof gapTime === 'undefined') {
    gapTime = 1500;
  }

  var _lastTime = null;

  // 返回新的函数
  return function () {
    var _nowTime = +new Date();
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(this, arguments); //将this和参数传给原函数
      _lastTime = _nowTime;
    } else {
      waitfn && waitfn();
    }
  };
}

/**
 * 时间格式化
 * 
 * @param  {date}   date      传人时间
 * @param  {boolean} normalization 是否需要标准时间格式
 * @return {string}           返回格式化的时间
 */
function getDate(date, normalization) {
  var invalidDate = '无效的时间';

  // check date valid
  if (Object.prototype.toString.call(date) === "[object Date]") {
    if (isNaN(date.getTime())) {
      return invalidDate;
    }
  } else {
    return invalidDate;
  }

  var offset = date.getTimezoneOffset() / 60;
  var reg = /^((\d{4})-(\d{2})-(\d{2}))T((\d{2}):(\d{2})):[^:]*$/;
  var els = reg.exec(date.toISOString());

  if (els) {
    var now = new Date();
    var isoNowEls = reg.exec(now.toISOString());
    var today = new Date([isoNowEls[1].replace(/-/g, '/'), isoNowEls[5].replace(/\d/g, '0')].join(' '));
    var times = now.getTime() - date.getTime();
    if (times < 0) {
      console('错误，历史时间大于当前时间');
      return invalidDate;
    }

    // 当天
    times = today.getTime() - date.getTime();
    var timeStr = [(+els[6] - offset) % 24, +els[7]].join(':').replace(/^(\d{1})\:/, '0$1:').replace(/\:(\d{1})$/, ':0$1');
    if (times <= 0) {
      return timeStr;
    }

    var days = times / (24 * 60 * 60 * 1000);
    if (days <= 1) {
      return '昨天';
    } else if (days <= 2) {
      return '前天';
    } else if (days <= 7) {
      return Math.floor(days) + '\u5929\u524D';
    }
    var dateStr = +els[3] + '\u6708' + +els[4] + '\u65E5';
    if (isoNowEls[2] - els[2] === 0) {
      return dateStr;
    }
    if (normalization === true) {
      return [+els[2] + '\u5E74' + dateStr, timeStr].join(' ');
    }
    return [els[1].split('-').map(function (i) {
      return +i;
    }).join('/'), timeStr].join(' ');
  } else {
    console.log('时间格式错误');
    return invalidDate;
  }
}

// 微信小程序获取当前页面带参数url
function getCurrentPageUrl() {
  var pages = getCurrentPages(); // 获取加载的页面
  var currentPage = pages[pages.length - 1]; // 获取当前页面的对象
  var url = currentPage.route; // 当前页面url
  var options = currentPage.options; // 如果要获取url中所带的参数可以查看options

  //拼接url的参数
  var urlWithArgs = url + '?';
  for (var key in options) {
    var value = options[key];
    urlWithArgs += key + '=' + value + '&';
  }
  urlWithArgs = urlWithArgs.substring(0, urlWithArgs.length - 1);

  return urlWithArgs;
}

// 测试用
function printMsg() {
  console.log("This is a message from the this package");
}

exports.default = { throttle: throttle, getDate: getDate, printMsg: printMsg, getCurrentPageUrl: getCurrentPageUrl };
